<template>
    <div id="main" class="pl-md-3">
        <nav v-bind:class="active" v-on:click.prevent>
            <input class="popular" v-on:click="makeActive('popular')" value="Popular Areas" type="button">
            <input class="alphabetical" v-on:click="makeActive('alphabetical','alpha')" value="A-Z" type="button">
            <input class="nearBy pt-3 pt-lg-1 pt-md-1" v-on:click="makeActive('nearBy','close')"
                   v-bind:value="'Near By ' + this.$attrs.location + ', ' + this.$attrs.province" type="button">
        </nav>

        <div class="p-3">
            <div v-if="azFilter" class="row mb-3">
                <div class="col-12 col-sm-8 col-md-6 col-lg-4">
                    <v-select v-model="selected" label="plName" :options="arrProvince" :clearable="false"
                              class="style-chooser">
                    </v-select>
                </div>
            </div>

            <div class="row">
                <div class="col" v-for="column in columns">
                    <a class="cities" :href="'/location/set/' + city.plInitials + '/' + city.plName"
                       v-for="(city, index) in column" v-if="index < limitPerCol">
                        <p v-if="azFilter">
                            {{ city.plName }}
                        </p>
                        <p v-else>
                            {{ city.plName }}, {{ city.plInitials }}
                        </p>
                    </a>
                </div>
            </div>
        </div>

        <button @click="show()" class="btn btn-link">
            {{ btnText }}
            <i class="arrowRight" v-if="btnText === 'Show More'"></i>
            <i class="las la-arrow-up" v-if="btnText === 'Show Less'"></i>
        </button>
    </div>

</template>

<script>
import vSelect from "vue-select";
import "vue-select/src/scss/vue-select.scss";

Vue.component("v-select", vSelect);
export default {
    name: "CityFilter",
    props: {
        textMore: {
            type: String,
            default: "Show More",
        },
        textLess: {
            type: String,
            default: "Show Less",
        },
        locationsAlphabetical: Array,
        locationsCloseBy: Array,
        locationsMostPopular: Array,
    },
    data() {
        return {
            active: "",
            btnText: "",
            cities: [],
            limitPerCol: 0,
            citiesDisplayed: 0,
            cols: 3,
            azFilter: false,
            selected: this.$attrs.provinceName,
            arrProvince: [
                {plInitials: "AB", plName: "Alberta"},
                {plInitials: "BC", plName: "British Columbia"},
                {plInitials: "ON", plName: "Ontario"}
            ],
        };
    },
    mounted() {
        this.makeActive("popular");
        this.initNumOfColumns();
    },
    computed: {
        columns() {
            let columns = [];
            let mid, arrCities;
            if (this.azFilter) {
                mid = Math.ceil(this.listByProvince.length / this.cols);
                arrCities = this.listByProvince;
            } else {
                mid = Math.ceil(this.cities.length / this.cols);
                arrCities = this.cities;
            }
            for (let col = 0; col < this.cols; col++) {
                columns.push(arrCities.slice(col * mid, col * mid + mid));
            }
            return columns;
        },
        isMobile() {
            return !(this.cols > 2);
        },
        listByProvince() {
            let filteredCities = [];
            if (this.selected.plName === undefined) {
                for (let i = 0; i < this.arrProvince.length; i++) {
                    if (this.arrProvince[i].plName === this.selected)
                        this.selected = this.arrProvince[i]
                }
            }
            for (let i = 0; i < this.locationsAlphabetical.length; i++) {
                if (this.locationsAlphabetical[i].plInitials === this.selected.plInitials || this.locationsAlphabetical[i].plInitials === this.selected) {
                    filteredCities[i] = this.locationsAlphabetical[i];
                }
            }

            filteredCities = filteredCities.filter(function (value) {
                return value != undefined;
            });

            return filteredCities;
        }
    },
    methods: {
        initNumOfColumns() {
            //mobile devices will only have 1 column
            if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                this.cols = 1;
            }
            //iPads (not sure if we can check other tablets) will have 2 columns
            else if (/iPad/i.test(navigator.userAgent)) {
                this.cols = 2;
            }
            //other devices will have 3 columns as initialized in the data() function
        },
        makeActive: function (item, filter = null) {
            this.active = item;
            this.limitPerCol = 9;
            this.btnText = this.textMore;

            switch (filter) {
                case "alpha":
                    this.azFilter = true;
                    this.cities = this.listByProvince;
                    break;
                case "close":
                    this.azFilter = false;
                    this.cities = this.locationsCloseBy;
                    break;
                default:
                    this.azFilter = false;
                    this.cities = this.locationsMostPopular;
                    break;
            }
        },
        show() {
            //Dynamically updating for A-Z filter
            let arrCities;
            if (this.azFilter) {
                arrCities = this.listByProvince;
            } else {
                arrCities = this.cities;
            }
            //Checking if device has 1 or 3 columns
            if (this.isMobile) {
                this.citiesDisplayed = this.limitPerCol;
            } else {
                this.citiesDisplayed = this.limitPerCol * 3;
            }
            //Toggle show more/less text
            if (arrCities.length > this.citiesDisplayed) {
                this.limitPerCol += 9;
                if (arrCities.length <= this.limitPerCol || (arrCities.length <= this.citiesDisplayed + 30 && !this.isMobile))
                    this.btnText = this.textLess;
            } else {
                this.btnText = this.textMore;
                this.limitPerCol = 9;
            }
        },
    },
    watch: {
        locationsAlphabetical: function () {
            this.cities = this.listByProvince;
        },
        locationsCloseBy: function () {
            this.cities = this.locationsCloseBy;
        },
        locationsMostPopular: function () {
            this.cities = this.locationsMostPopular;
        }
    }
}
</script>

<style lang="scss" scoped>

nav input:hover, nav input:active {
    text-decoration: none;
    color: #FF7546;
    border: none;
    outline: none;
}

nav input {
    display: inline-block;
    color: gray;
    background-color: transparent;
    border: none;
    padding-left: 1em;
    font-weight: bold;
    font-size: 1.15em;
    text-decoration: none !important;
    line-height: 1;

    -webkit-transition: background-color 0.25s;
    -moz-transition: background-color 0.25s;
    transition: background-color 0.25s;
}

nav.popular .popular,
nav.alphabetical .alphabetical,
nav.nearBy .nearBy {
    color: #00937F;
    border: none;
    outline: none;
}

.cities {
    color: black;
    text-decoration: none;
}

.cities:hover {
    text-decoration: none;
    color: #FF7546;
}

.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
{
    border-radius: 5rem;
}
</style>
